
import { mapActions, mapMutations } from 'vuex'
export default {
  props: {
    wording: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    ...mapActions({
      vxResetAllSearch: 'search/resetAllSearch',
    }),
    ...mapMutations({
      vxResetSearchResults: 'search/resetSearchResults',
    }),
    doFilterReset() {
      this.vxResetSearchResults('filtering')
      this.vxResetAllSearch()
      const toggledDropdown = document.querySelector('.filter-dropdown.toggled')
      if (toggledDropdown) {
        toggledDropdown.click()
      }

      const toggledButton = document.querySelector('.filter-toggle.toggled')
      if (toggledButton) {
        toggledButton.click()
      }
    },
  },
}
